import React, { useEffect, useRef } from "react";
import "../Home.css";
import "./HowItWorksSection.css";

export default function HowItWorksSection({ t, lang, flatMobile = false }) {
  const howXRef = useRef(null);

  useEffect(() => {
    const el = howXRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-in");
          io.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <>
      {!flatMobile && <div className="section-wave" aria-hidden="true" />}
      <section
        className={`howX section-sand${flatMobile ? " how-it-works--flat" : ""}`}
        id="how-it-works"
        ref={howXRef}
      >
        <div className="container">
          <h2 className="home-section-title section-title-centered scroll-animate from-bottom delay-1">
            {t.howTitle}
          </h2>
          <div className="hx-grid-desktop" role="list" key={lang}>
            <div className="hx-line" aria-hidden="true" />
            {t.howSteps
              .filter((s) => !s.isFinal && !s.hideOnDesktop)
              .map((s, i) => (
                <article
                  className={`hx-step scroll-animate from-bottom delay-${Math.min(i + 2, 6)}`}
                  key={`${lang}-${s.title}`}
                  style={{ "--i": i }}
                >
                  <span className="hx-dot" aria-hidden="true" />
                  <div className="hx-step-content">
                    <h3 className="hx-h">{s.title}</h3>
                    <p className="hx-p">{s.description}</p>
                  </div>
                </article>
              ))}
          </div>
          <div className="how-card-mobile">
            <div className={`how-timeline ${lang === "ar" ? "how-timeline-rtl" : ""}`}>
              <div className={`how-rail ${lang === "ar" ? "how-rail-rtl" : ""}`} aria-hidden="true" />
              {t.howSteps.map((step, index) => (
                <div
                  key={step.title}
                  className={`how-step-row scroll-animate from-bottom delay-${Math.min(index + 2, 6)} ${lang === "ar" ? "how-step-row-rtl" : ""}`}
                >
                  <div className={`how-step-left ${lang === "ar" ? "how-step-left-rtl" : ""}`}>
                    <div className="how-badge-glow">
                      <div className="how-step-badge" />
                    </div>
                  </div>
                  <div className={`how-step-content ${lang === "ar" ? "how-step-content-rtl" : ""}`}>
                    <h3
                      className={`how-step-title ${step.isFinal ? "how-step-title-compact" : ""} ${lang === "ar" ? "text-right" : ""}`}
                    >
                      {step.title}
                    </h3>
                    <p className={`how-step-subtitle ${lang === "ar" ? "text-right" : ""}`}>
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className="section-wave section-wave--light" aria-hidden="true" />
    </>
  );
}
